import comma from '../../../assets/images/about/culture/comma.png'
import structure from '../../../assets/images/about/culture/structure.png'
import pyramid from '../../../assets/images/about/culture/1353.png'
import strategyBg from '../../../assets/images/about/culture/strategy-bg.png'

import values1 from '../../../assets/images/about/culture/values01.png'
import values2 from '../../../assets/images/about/culture/values02.png'
import values3 from '../../../assets/images/about/culture/values03.png'
import values4 from '../../../assets/images/about/culture/values04.png'

import styles from './style.module.scss'
import { Tabs } from 'antd'
import { useState } from 'react'

const items = [
    {
        index: 1,
        label: '客户导向',
        children: (
            <div className={styles['values-container']}>
                <div className={styles['content']}>
                    <p>烽火星空坚持以客户为中心，客户永远是公司的生存之本，客户导向永远是指引企业不断前进的指南针。 </p>
                    <p>我们坚持把客户需求作为工作的出发点，深刻理解客户的现实需求，挖掘客户的潜在需求，围绕客户感知和体验，着力打造匠心产品，提供匠心服务。 </p>
                    <p>我们基于客户需求建立目标导向、责任导向和结果导向，坚持把提升客户满意度作为检验工作价值的标准，鼓励站在客户的角度来提升工作质量。 </p>
                </div>
                <img src={values1} alt="" />
            </div>
        )
    },
    {
        index: 2,
        label: '工匠精神',
        children: (
            <div className={styles['values-container']}>
                <div className={styles['content']}>
                    <p>持续发挥员工潜能，精工细作，倡导走数字工匠“技能报国”之路，传承“工匠精神”，争当数字化“大国工匠”。 </p>
                    <p>牢记核心技术、关键技术立足自身，为强化国家战略科技贡献力量，以“匠心”打造信息领域“国之重器”。 </p>
                    <p>深耕产业发展诉求，打造面向重点行业的全场景数字化解决方案，系统推进企业数字化生态构建，重塑数字化领导力，为“数字中国”建设贡献“烽火力量”。 </p>
                </div>
                <img src={values2} alt="" />
            </div>
        )
    },
    {
        index: 3,
        label: '务实创新',
        children: (
            <div className={styles['values-container']}>
                <div className={styles['content']}>
                    <p>实干创造数据价值，创新引领企业发展。务实创新是烽火星空不断发展的动力引擎。 </p>
                    <p>实干要讲究科学的方式方法、正确的理论指导。要立足实际情况，遵循规律，掌握特点，精准发力。 </p>
                    <p>实干体现出的实效，最终直观地反映在产品质量上，只有高质量的产品才能引领未来。 </p>
                    <p>信息产业技术的竞争将比传统产业更激烈，后退就意味着消亡，要在这个产业中生存，必须有“甘坐冷板凳”的专注精神，摒弃浮躁，潜心钻研，不断追求技术革新。</p>
                    <p>我们倡导员工做新时代真正的不断改革的实干家，出实策、鼓实劲，不图虚名，不务虚功，承担起我们这一代人的历史责任和使命。</p>
                </div>
                <img src={values3} alt="" />
            </div>
        )
    },
    {
        index: 4,
        label: '诚信敬业',
        children: (
            <div className={styles['values-container']}>
                <div className={styles['content']}>
                    <p>以诚志信，以信取胜，是我们与客户交往的基本原则。我们鼓励公平竞争、合规经营、信守承诺，用诚信赢得客户；鼓励说到做到，不弄虚作假，不隐瞒欺骗，不自欺欺人；鼓励不捂盖子，对于组织和流程运作中存在的问题，敢于直言，敢于承担责任。 </p>
                    <p>爱岗敬业，恪尽职守，是我们对员工职业道德的基本要求。我们鼓励立足本职岗位，干一行，爱一行、专一行、成一行，自觉履行职业责任，专心致力于事业，努力追求职业生涯的更高境界。鼓励自动自发地完成工作，且能超出预期的期望；反对只做领导安排的事，领导不安排就不知道怎么做的行为。 </p>
                </div>
                <img src={values4} alt="" />
            </div>
        )
    }
];

const pillaiList = [
    {
        index: 1,
        title: '管理体制',
        content: [
            { index: 1, content: '管理体制设计以有效产出为中心，以客户满意为根本；' },
            { index: 2, content: '以贡献论英雄，以产出论回报。永远是那些愿冒最大风险、处在实现产出的关键路径上、善用关键资源、付出额外努力、做出独特贡献的人获得最高报酬；' },
            { index: 3, content: '创新型业务重点看领军人物，成熟型业务重点看经营团队；', },
            { index: 4, content: '深刻理解客户的现实需求，挖掘客户的潜在需求，融入或参与到客户的价值创造环节；', },
            { index: 5, content: '基于客户需求及其变化，不断优化业务流程，通过系统解决方案满足客户需求和价值增长的需要；', },
            { index: 6, content: '增量是我们的内生需求，只有组织绩效的增量，才有员工收入的增长。', },
        ]
    },
    {
        index: 2,
        title: '人才机制',
        content: [
            { index: 1, content: '鼓励务实创新，实干可能要冒一定的风险。有风险就有机遇。反对只看到风险看不到机遇，担心有余、担当不足。不作为是实干攻坚的最大阻碍、最深隐患；', },
            { index: 2, content: '鼓励对照标杆找差距，千方百计把工作做到最好；反对”不求有功、但求无过“的慵懒思想；', },
            { index: 3, content: '以产出、增量、独特贡献、额外努力和人才培养作为评价干部的基准，大胆使用优点与个性鲜明的人；', },
            { index: 4, content: '个人职业能力匹配组织发展需求。鼓励从提升组织绩效的角度出发，不断发展个人职业能力；反对脱离组织实际需求，为追求高难度的工作成果而去提升个人能力；', },
            { index: 5, content: '真正的专家从市场一线来，也要走向市场一线；', },
            { index: 6, content: '鼓励横向流动，具有跨领域工作经历的人优先获得晋升。' },
        ]
    },
    {
        index: 3,
        title: '创新规则',
        content: [
            { index: 1, content: '创新的生命力来源于客户需求。鼓励重视客户需求和最终应用感知的创新；反对片面追求技术领先性，以及基于个人兴趣与爱好的创新；', },
            { index: 2, content: '以创新引领，培育新动能，激发新活力。积极探求大数据、人工智能和重点行业领域的集成创新，不断推动创新成果的转化和落地，使创新真正成为企业实现超越发展的引擎；', },
            { index: 3, content: '创新不等于推倒重来，继承不等于墨守成规，鼓励基于知识共享的开放式创新；', },
            { index: 4, content: '小改进是重要的创新形式。鼓励降本增效、提升品质的小改进，反对脱离实际的大建议；', },
            { index: 5, content: '创新有风险，允许犯错。鼓励用宽容的心态对待挫折和失败；反对因循守旧、不思进取、凡事不敢越雷池一步。' },
        ]
    },
    {
        index: 4,
        title: '沟通模式',
        content: [
            { index: 1, content: '鼓励基于解决问题、寻找有效路径的沟通；反对只讲问题不提建议的推诿； ', },
            { index: 2, content: '鼓励立足整体利益看“得失”；反对站在局部立场争“对错”； ', },
            { index: 3, content: '鼓励换位思考，分析问题先说自己，总结经验先说别人； ', },
            { index: 4, content: '鼓励直接、当面沟通解决问题；反对不考虑效果，单纯以电子邮件、短信、微信或他人转 述等方式单向告知； ', },
            { index: 5, content: '坚持年度规划/季度计划/月度计划/周报等有效沟通方式。' },
        ]
    }
];

const Culture = () => {

    const [activeIndex, setActiveIndex] = useState(1);

    return (
        <div className={styles['culture-wrapper']}>
            <div className={styles['title-wrapper']}>用数据创造价值</div>
            <div className={styles['idea-wrapper']}>
                <p>企业战略文化理念</p>
                <div className={styles['idea-content']}>
                    <img src={comma} alt="" />
                    <div className={styles['content']}>
                        <p>烽火星空的企业文化体系机构主要包括三大基石和四大支柱，</p>
                        <p>其中三大基石是指使命愿景、发展战略、核心价值观，它明确了公司的发展方向和发展路径，在公司内部形成了统一的指导思想、基本的道德规范和行为准则。</p>
                        <p>四个支柱是指管理体制、人才机制、创新规则和沟通模式，这是支撑星空文化落地的有效手段和方法，是确保星空文化生生不息的重要源泉。</p>
                    </div>
                    <img src={structure} alt="" />
                </div>
                <div className={styles['pyramid-wrapper']}>
                    <div className={styles['mission-wrapper']}>
                        <div className={styles['title']}>企业使命</div>
                        <div className={styles['content']}>让城市更安全&nbsp;让政府更高效</div>
                    </div>
                    <div className={styles['vision-wrapper']}>
                        <div className={styles['title']}>企业愿景</div>
                        <div className={styles['content']}>打造信息领域的国之重器</div>
                    </div>
                    <div className={styles['strategy-wrapper']}>
                        <div className={styles['title']}>发展战略</div>
                        <div className={styles['strategy-content']}>
                            <p className={styles['title']}>“1353”战略</p>
                            <img src={pyramid} alt="" />
                        </div>
                        <img src={strategyBg} alt="" />
                    </div>
                </div>
            </div>
            <div className={styles['values-wrapper']}>
                <p>核心价值观</p>
                <p>客户导向 工匠精神 务实创新 诚信敬业</p>
                <Tabs
                    defaultActiveKey='1'
                    tabPosition='left'
                    items={items.map((item) => (
                        {
                            label: item.label,
                            key: String(item.index + 1),
                            children: item.children
                        }
                    ))} />
            </div>
            <div className={styles['pillar-wrapper']}>
                <p>四个支柱</p>
                <p>烽火星空企业文化的四个支柱主要包括管理体制、人才机制、创新规则、沟通模式等方面的内容。</p>
                <div className={styles['pillar-container']}>
                    {pillaiList.map((item) => (
                        <div
                            className={`${styles['pillar-item']} ${item.index === activeIndex ? styles['active'] : ''}`}
                            key={item.index}
                            onMouseEnter={() => setActiveIndex(item.index)}
                        >
                            <p className={styles['title']}>{item.title}</p>
                            <ul>
                                {item.content.map((value) => (
                                    <li key={value.index}>{value.content}</li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}
export default Culture